<template>
  <router-view />
</template>
<script>

export default {
  name: 'AdminMaps',
}
</script>
